import { render, staticRenderFns } from "./SuperKidPublicHeader.vue?vue&type=template&id=5375cc5a&scoped=true&"
import script from "./SuperKidPublicHeader.vue?vue&type=script&lang=js&"
export * from "./SuperKidPublicHeader.vue?vue&type=script&lang=js&"
import style0 from "./SuperKidPublicHeader.vue?vue&type=style&index=0&id=5375cc5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5375cc5a",
  null
  
)

export default component.exports